import React, { useState, useEffect } from 'react';
import '@/pages/ReportViewer/ReportViewer.scss';
import {useTenantApi} from '@/hooks/useTenantApi';
import '@/pages/StoryViewer/BuildStory.scss';
import {alert as byzzerAlert} from '@/components/form/ByzzerModal'; // todo: We should consider renaming the alert component to avoid confusion with the native alert function.
import { ByzzerMask } from '@/components/ByzzerMask/ByzzerMask';
import './DownloadReportPage.scss';

const baseClassName = 'download-report-page';
            
const DownloadReportPage = (props) => {
    const [loading, setLoading] = useState(false);
    const { getReportFromAPI } = useTenantApi();

    const download = async () => {
        const actionId = JSON.parse(sessionStorage.getItem('reportActionId') || 'null');
        const selectedTileList = JSON.parse(sessionStorage.getItem('reportSelectedTileList') || '[]');
        try {
            // Used this instead of window.saveAs(blob, 'report'.zip) - to auto close the tab after downloading the file. 
            // In case of window.saveAs the tab closed even before the file was downloaded.
            setLoading(true);

            const result = await getReportFromAPI({
                actionId,
                tilesToDownload: selectedTileList
            });

            sessionStorage.removeItem('reportActionId');
            sessionStorage.removeItem('reportSelectedTileList');

            if (result && result?.status === 'success') {
                const [blob, zipName] = result.data;
                const url = window.URL || window.webkitURL;
                const link = url.createObjectURL(blob);
                const a = document.createElement("a");
                a.setAttribute("download", "dashboard-"+zipName.toLowerCase()+".zip");
                a.setAttribute("href", link);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                setLoading(false);
                window.close();
            } else {
                setLoading(false);
                console.error(`DownloadReportPage - error downloading report: ${result?.message}`);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
            byzzerAlert({content:'Error downloading report'});
        } finally {
            sessionStorage.removeItem('reportActionId');
            sessionStorage.removeItem('reportSelectedTileList');
        }
    };
    
    useEffect(() => {
        download();
    }, []);

    return (
        <div className={`${baseClassName}`}>
            <ByzzerMask className={`${baseClassName}__spinner`} show={loading} loading={loading}>Loading...</ByzzerMask>
        </div>
    );

    
};
export default DownloadReportPage;
